export default "__VITE_ASSET__DjqLfzVI__"